import { WarningOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const WarningIcon = styled(WarningOutlined)`
  color: #fa8c16;
  font-size: 20px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 24px;
`;

export const Divider = styled.div`
  height: 1px;
  background: #f0f0f0;
  width: 100%;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #000;
`;

export const Message = styled.p`
  margin: 0;
  padding: 16px 24px;
  font-size: 0.875rem;
  color: #000;

  strong {
    color: #f5222d;
  }
`;

export const SummarySection = styled.div`
  padding: 16px 24px;
`;

export const SummaryTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: 0 0 12px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid #e8e8e8;
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SummaryLabel = styled.span`
  color: #595959;
`;

export const SummaryValueHighlight = styled.span`
  color: #f5222d;
  font-weight: 600;
`;

export const SummaryValueSuccess = styled.span`
  color: #389e0d;
  font-weight: 600;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 24px 20px;
`;

export const CancelButton = styled.button`
  padding: 8px 24px;
  border: 1px solid #d9d9d9;
  background: white;
  color: #595959;
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    border-color: #f78e1e;
    color: #f78e1e;
  }

  @media (max-width: 768px) {
    flex: 1;
    padding: 12px 16px;
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 24px;
  border: none;
  background: #f78e1e;
  color: white;
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #e67010;
  }

  @media (max-width: 768px) {
    flex: 1;
    padding: 12px 16px;
  }
`;
